import script from "./AutoFit.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoFit.vue?vue&type=script&setup=true&lang=js"

import "./AutoFit.vue?vue&type=style&index=0&id=656ac6aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-656ac6aa"]])

export default __exports__